import { JSX } from "react";
import { LegendStatus } from "./LegendEnum";
import LegendItem from "./LegendItem";

import "./Legend.scss";
import { useAppSelector } from "store/store";
import { LEGEND_MODE } from "constants/navigation";
import { getLegendDisplayMode } from "store/Selectors/warehousePlanSelector";

const Legend: React.FC = () => {
  const legendStatus: LegendStatus[] = Object.values(LegendStatus);
  const legendItems: JSX.Element[] = [];
  const legendMode: LEGEND_MODE = useAppSelector(getLegendDisplayMode);

  legendStatus.forEach(status =>
    legendItems.push(<LegendItem key={status} legendStatus={status} />)
  );

  if (legendMode == LEGEND_MODE.NONE) {
    return null;
  }
  return (
    <div
      className={`legend ${legendMode == LEGEND_MODE.FULL ? "full-legend" : ""}`}>
      <p className="legend-title">Légende</p>
      <div className="legend-items">{legendItems}</div>
    </div>
  );
};
export default Legend;
